import { render, staticRenderFns } from "./preSale-forward-delivery-list.vue?vue&type=template&id=153747c0&scoped=true"
import script from "./preSale-forward-delivery-list.vue?vue&type=script&lang=js"
export * from "./preSale-forward-delivery-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153747c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153747c0')) {
      api.createRecord('153747c0', component.options)
    } else {
      api.reload('153747c0', component.options)
    }
    module.hot.accept("./preSale-forward-delivery-list.vue?vue&type=template&id=153747c0&scoped=true", function () {
      api.rerender('153747c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/preSale-management/preSale-order/preSale-forward-delivery-list.vue"
export default component.exports